import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'ld-statements-documents-skeleton',
  template: `
    <div id="statements-documents-skeleton" class="animate-pulse">
      <!-- Table Header -->
      <div
        class="grid grid-cols-[1fr_1fr_auto] md:grid-cols-[280px_1fr_auto] items-center px-4 md:px-10 py-4 bg-ld-neutral-50 border-b border-ld-border"
      >
        <div class="h-4 w-12 bg-gray-300 rounded"></div>
        <div class="h-4 w-12 bg-gray-300 rounded"></div>
        <div class="h-4 w-24 bg-gray-300 rounded"></div>
      </div>

      <!-- Table Rows -->
      @for (row of [1, 2, 3, 4, 5, 6, 7, 8]; track row) {
      <div
        class="grid grid-cols-[1fr_1fr_auto] md:grid-cols-[280px_1fr_auto] items-center px-4 md:px-10 py-4 border-b border-ld-border"
      >
        <div class="h-5 w-24 bg-gray-200 rounded"></div>
        <div class="h-5 w-40 bg-gray-200 rounded"></div>
        <div class="flex gap-2">
          <div class="h-8 w-16 bg-gray-200 rounded-lg"></div>
          <div class="h-8 w-24 bg-gray-200 rounded"></div>
        </div>
      </div>
      }

      <!-- Pagination Skeleton -->
      <div class="px-6 py-3 flex items-center justify-end gap-4 border-t border-ld-border">
        <div class="h-4 w-32 bg-gray-200 rounded"></div>
        <div class="flex items-center gap-1">
          <div class="h-8 w-8 bg-gray-200 rounded"></div>
          <div class="h-8 w-8 bg-gray-200 rounded"></div>
          <div class="h-8 w-8 bg-gray-200 rounded"></div>
          <div class="h-8 w-8 bg-gray-200 rounded"></div>
        </div>
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatementsDocumentsSkeletonComponent {}
